import { useFirebaseConfig } from "./remote-config";

export default function useReigniteMetadata() {
  const firebaseConfig = useFirebaseConfig()

  return {
    isFetchingFirebaseConfig: !firebaseConfig.initialized,
    isReigniteMetadataAvailable: firebaseConfig.config.useReigniteMetadata?.asBoolean() ?? false,
  }
}